import { render, staticRenderFns } from "./PrivilegeDetailPanelNewLayout.vue?vue&type=template&id=78bcef4b&scoped=true"
import script from "./PrivilegeDetailPanelNewLayout.vue?vue&type=script&lang=js"
export * from "./PrivilegeDetailPanelNewLayout.vue?vue&type=script&lang=js"
import style0 from "./PrivilegeDetailPanelNewLayout.vue?vue&type=style&index=0&id=78bcef4b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78bcef4b",
  null
  
)

export default component.exports